export default "__VITE_ASSET__Cg$3SCnw__"